import {
  useExchangesMetadata,
  usePrevious,
  useSymbolsMetadata,
} from "@shared/utils/hooks/misc.ts";
import { difference } from "lodash";
import { useEffect, useMemo, useState } from "react";

interface useTradingViewChartExchangeSelectorProps {
  exchanges?: string[];
  symbol?: string;
}

export const useTradingViewChartExchangeSelector = ({
  exchanges,
  symbol,
}: useTradingViewChartExchangeSelectorProps) => {
  const { exchanges: allExchanges } = useExchangesMetadata();
  const { getSymbolExchanges } = useSymbolsMetadata();
  const [exchange, setExchange] = useState<string>();
  const prevExchanges = usePrevious(exchanges);

  useEffect(() => {
    const removedExchanges = difference(prevExchanges || [], exchanges || []);
    const selectedExchangeRemoved =
      exchange &&
      removedExchanges.length &&
      removedExchanges.includes(exchange);
    if (!exchange || selectedExchangeRemoved) {
      setExchange(exchanges?.[0]);
    }
  }, [exchanges]);

  const symbolExchanges = useMemo(
    () => (symbol ? getSymbolExchanges(symbol) : allExchanges),
    [getSymbolExchanges, symbol]
  );

  return {
    symbolExchanges,
    exchange,
    setExchange,
  };
};
